import { DurationUnitKey, Preset } from './types';

export const CUSTOM_PRESET: Preset = {
  label: 'Custom',
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
};

export const OFF_PRESET: Preset = {
  label: 'Off',
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
};

export const DAY_HOUR_PRESETS: Preset[] = [
  { label: '3h', days: 0, hours: 3, minutes: 0, seconds: 0 },
  { label: '12h', days: 0, hours: 12, minutes: 0, seconds: 0 },
  { label: '1d', days: 1, hours: 0, minutes: 0, seconds: 0 },
  { label: '3d', days: 3, hours: 0, minutes: 0, seconds: 0 },
  { label: '7d', days: 7, hours: 0, minutes: 0, seconds: 0 },
];

export const HOUR_MINUTE_PRESETS: Preset[] = [
  { label: '15m', days: 0, hours: 0, minutes: 15, seconds: 0 },
  { label: '30m', days: 0, hours: 0, minutes: 30, seconds: 0 },
  { label: '1h', days: 0, hours: 1, minutes: 0, seconds: 0 },
  { label: '6h', days: 0, hours: 6, minutes: 0, seconds: 0 },
  { label: '12h', days: 0, hours: 12, minutes: 0, seconds: 0 },
  { label: '24h', days: 0, hours: 24, minutes: 0, seconds: 0 },
];

export const MINUTE_SECOND_PRESETS: Preset[] = [
  { label: '2m', days: 0, hours: 0, minutes: 2, seconds: 0 },
  { label: '10m', days: 0, hours: 0, minutes: 10, seconds: 0 },
  { label: '15m', days: 0, hours: 0, minutes: 15, seconds: 0 },
  { label: '30m', days: 0, hours: 0, minutes: 30, seconds: 0 },
];

export const EVICTION_DELAY_PRESETS: Preset[] = [
  { label: '60s', days: 0, hours: 0, minutes: 1, seconds: 0 },
  { label: '5m', days: 0, hours: 0, minutes: 5, seconds: 0 },
  { label: '60m', days: 0, hours: 0, minutes: 60, seconds: 0 },
];

export const DEFAULT_UNIT_CONFIG: Record<
  DurationUnitKey,
  { min: number; max: number }
> = {
  days: { min: 0, max: 7 },
  hours: { min: 0, max: 23 },
  minutes: { min: 0, max: 59 },
  seconds: { min: 0, max: 59 },
};

export const DEFAULT_UNIT_LABEL: Record<DurationUnitKey, string> = {
  days: 'd',
  hours: 'h',
  minutes: 'min',
  seconds: 'sec',
};
